import axios from 'axios'
import store from '@/store'

const API_BASE = 'https://residencial-services.intrare.app'

export default {
  /**
   * Obtiene lista de residencias aprobadas del usuario
   * @returns {Promise} Lista de residencias
   */
  async getMyResidences () {
    const url = `${API_BASE}/my_residences/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching residences:', error)
      throw error
    }
  },

  /**
   * Obtiene lista de residenciales disponibles
   * @returns {Promise} Lista de residenciales
   */
  async getHousingUnits () {
    const url = `${API_BASE}/housing_unit/all/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching housing units:', error)
      throw error
    }
  },

  /**
   * Obtiene lista de casas disponibles de una residencial específica
   * @param {string} idHousingUnit - ID de la residencial
   * @returns {Promise} Lista de casas
   */
  async getAvailableHousesByUnit (idHousingUnit) {
    const url = `${API_BASE}/house/${idHousingUnit}/housingunit/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching houses:', error)
      throw error
    }
  },

  /**
   * Obtiene lista de casas disponibles (todas)
   * @returns {Promise} Lista de casas
   */
  async getAvailableHouses () {
    const url = `${API_BASE}/house/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching houses:', error)
      throw error
    }
  },

  /**
   * Cambia el domicilio activo del usuario
   * @param {string} idResident - ID del residente a activar
   * @returns {Promise} Datos del usuario actualizado
   */
  async switchResidence (idResident) {
    const url = `${API_BASE}/switch_residence/`

    try {
      const response = await axios.post(url, {
        idResident: idResident
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error switching residence:', error)
      throw error
    }
  },

  /**
   * Solicita agregar un nuevo domicilio
   * @param {string} idHouse - ID de la casa
   * @returns {Promise} Confirmación de solicitud
   */
  async requestAddHouse (idHouse) {
    const url = `${API_BASE}/add_house/`

    try {
      const response = await axios.post(url, {
        idHouse: idHouse
      }, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error requesting house:', error)
      throw error
    }
  },

  /**
   * Obtiene las solicitudes de domicilio pendientes del residente autenticado
   * @returns {Promise} Lista de solicitudes pendientes del usuario
   */
  async getPendingHouseRequests () {
    const url = `${API_BASE}/pending_house_requests/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching my pending house requests:', error)
      throw error
    }
  },

  /**
   * Obtiene lista de todos los residentes del residencial (solo admin)
   * @returns {Promise} Lista de residentes
   */
  async getAllResidents () {
    const url = `${API_BASE}/residents/all`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data.residents || []
    } catch (error) {
      console.error('Error fetching residents:', error)
      throw error
    }
  },

  /**
   * Obtiene lista de solicitudes pendientes (solo admin)
   * @returns {Promise} Lista de solicitudes
   */
  async getPendingRequests () {
    const url = `${API_BASE}/pending_residents/`

    try {
      const response = await axios.get(url, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching pending requests:', error)
      throw error
    }
  },

  /**
   * Valida solicitud de nuevo domicilio (solo admin)
   * @param {string} residentId - ID del residente
   * @param {string} action - 'approve' o 'reject'
   * @param {string} feedback - Motivo del rechazo (opcional)
   * @returns {Promise} Confirmación de validación
   */
  async validateAddHouse (residentId, action, feedback = '') {
    const url = `${API_BASE}/validate_add_house/${residentId}/`

    try {
      const body = { action }
      if (action === 'reject' && feedback) {
        body.feedback = feedback
      }

      const response = await axios.patch(url, body, {
        headers: {
          'Authorization': `Token ${store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data
    } catch (error) {
      console.error('Error validating house request:', error)
      throw error
    }
  }
}
